import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import hash from 'hash-sum';
import AntLocalization from '../utils/AntLocalization';
import { AntGlobal } from '../utils/AntContext';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';

// import AntIcon from './AntIcon';

const hexToRgb = (hex) => {
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
};

// Hàm giảm sáng để đảm bảo màu tối
const darkenColor = (hex, factor = 0.5) => {
    const { r, g, b } = hexToRgb(hex);
    const newR = Math.floor(r * factor);
    const newG = Math.floor(g * factor);
    const newB = Math.floor(b * factor);
    return `rgb(${newR}, ${newG}, ${newB})`;
};

export default function (props) {
    const appGlobal = AntGlobal();

    const renderText = useCallback((cell) => {
        var tags = cell.tags ? cell.tags : [];

        var style = cell.style ? JSON.parse(stringify(cell.style)) : {};

        if (cell.width) style = { ...style, width: cell.width };

        if (cell.text9) style = { ...style, fontSize: 9 };
        if (cell.text10) style = { ...style, fontSize: 10 };
        if (cell.text11) style = { ...style, fontSize: 11 };
        if (cell.text12) style = { ...style, fontSize: 12 };
        if (cell.text13) style = { ...style, fontSize: 13 };
        if (cell.text14) style = { ...style, fontSize: 14 };
        if (cell.text15) style = { ...style, fontSize: 15 };
        if (cell.text16) style = { ...style, fontSize: 16 };
        if (cell.text17) style = { ...style, fontSize: 17 };
        if (cell.text18) style = { ...style, fontSize: 18 };
        if (cell.text19) style = { ...style, fontSize: 19 };
        if (cell.text21) style = { ...style, fontSize: 21 };
        if (cell.text20) style = { ...style, fontSize: 20 };
        if (cell.text22) style = { ...style, fontSize: 22 };
        if (cell.text23) style = { ...style, fontSize: 23 };
        if (cell.text24) style = { ...style, fontSize: 24 };
        if (cell.text25) style = { ...style, fontSize: 25 };
        if (cell.text26) style = { ...style, fontSize: 26 };
        if (cell.text27) style = { ...style, fontSize: 27 };
        if (cell.text28) style = { ...style, fontSize: 28 };
        if (cell.text29) style = { ...style, fontSize: 29 };
        if (cell.text30) style = { ...style, fontSize: 30 };
        if (cell.text31) style = { ...style, fontSize: 31 };
        if (cell.text32) style = { ...style, fontSize: 32 };
        if (cell.text33) style = { ...style, fontSize: 33 };
        if (cell.text34) style = { ...style, fontSize: 34 };
        if (cell.text35) style = { ...style, fontSize: 35 };
        if (cell.text36) style = { ...style, fontSize: 36 };

        if (cell.bold9) style = { ...style, fontSize: 9, fontWeight: 'bold' };
        if (cell.bold10) style = { ...style, fontSize: 10, fontWeight: 'bold' };
        if (cell.bold11) style = { ...style, fontSize: 11, fontWeight: 'bold' };
        if (cell.bold12) style = { ...style, fontSize: 12, fontWeight: 'bold' };
        if (cell.bold13) style = { ...style, fontSize: 13, fontWeight: 'bold' };
        if (cell.bold14) style = { ...style, fontSize: 14, fontWeight: 'bold' };
        if (cell.bold15) style = { ...style, fontSize: 15, fontWeight: 'bold' };
        if (cell.bold16) style = { ...style, fontSize: 16, fontWeight: 'bold' };
        if (cell.bold17) style = { ...style, fontSize: 17, fontWeight: 'bold' };
        if (cell.bold18) style = { ...style, fontSize: 18, fontWeight: 'bold' };
        if (cell.bold19) style = { ...style, fontSize: 19, fontWeight: 'bold' };
        if (cell.bold20) style = { ...style, fontSize: 20, fontWeight: 'bold' };
        if (cell.bold21) style = { ...style, fontSize: 21, fontWeight: 'bold' };
        if (cell.bold22) style = { ...style, fontSize: 22, fontWeight: 'bold' };
        if (cell.bold23) style = { ...style, fontSize: 23, fontWeight: 'bold' };
        if (cell.bold24) style = { ...style, fontSize: 24, fontWeight: 'bold' };
        if (cell.bold25) style = { ...style, fontSize: 25, fontWeight: 'bold' };
        if (cell.bold26) style = { ...style, fontSize: 26, fontWeight: 'bold' };
        if (cell.bold27) style = { ...style, fontSize: 27, fontWeight: 'bold' };
        if (cell.bold28) style = { ...style, fontSize: 28, fontWeight: 'bold' };
        if (cell.bold29) style = { ...style, fontSize: 29, fontWeight: 'bold' };
        if (cell.bold30) style = { ...style, fontSize: 30, fontWeight: 'bold' };
        if (cell.bold31) style = { ...style, fontSize: 31, fontWeight: 'bold' };
        if (cell.bold32) style = { ...style, fontSize: 32, fontWeight: 'bold' };
        if (cell.bold33) style = { ...style, fontSize: 33, fontWeight: 'bold' };
        if (cell.bold34) style = { ...style, fontSize: 34, fontWeight: 'bold' };
        if (cell.bold35) style = { ...style, fontSize: 35, fontWeight: 'bold' };
        if (cell.bold36) style = { ...style, fontSize: 36, fontWeight: 'bold' };

        if (cell.left) style = { ...style, justifyContent: 'flex-start' };
        if (cell.right) style = { ...style, justifyContent: 'flex-end' };
        if (cell.center) style = { ...style, justifyContent: 'center' };

        if (cell.upper) style = { ...style, textTransform: 'uppercase' };

        style = { ...style, ...cell.style };

        tags = tags.reduce((obj, i) => ((obj[i] = true), obj), {});

        if (cell.tags instanceof Array) {
            if (cell.tags.includes('lineLightColor')) style = { ...style, color: '#EBEBEB' };
            if (cell.tags.includes('grayTextColor')) style = { ...style, color: '#66627E' };
            if (cell.tags.includes('darkgrayTextColor')) style = { ...style, color: '#66627E' };
            if (cell.tags.includes('textLightColor')) style = { ...style, color: '#D8D8D8' };
            if (cell.tags.includes('disabledColor')) style = { ...style, color: '#D8D8D8' };
            if (cell.tags.includes('linkColor')) style = { ...style, color: '#009DF6' };
            if (cell.tags.includes('buttonBGColor')) style = { ...style, color: '#EDEFFF' };
            if (cell.tags.includes('placeholderColor')) style = { ...style, color: '#97A7B5' };
            if (cell.tags.includes('tabBarColor')) style = { ...style, color: '#E7E8F2' };
            if (cell.tags.includes('tabBarSelectedColor')) style = { ...style, color: '#DEDEFF' };
            if (cell.tags.includes('grayBorderColor')) style = { ...style, color: '#B4B4B4' };

            if (cell.tags.includes('primaryColor')) style = { ...style, color: '#6271E0' };
            if (cell.tags.includes('secondaryColor')) style = { ...style, color: '#6A75C3' };
            if (cell.tags.includes('textColor')) style = { ...style, color: '#66627E' };
            if (cell.tags.includes('errorColor')) style = { ...style, color: '#F84B64' };
            if (cell.tags.includes('successColor')) style = { ...style, color: '#009DF6' };
            if (cell.tags.includes('warnColor')) style = { ...style, color: '#FF963C' };

            if (cell.tags.includes('primaryBGColor')) style = { ...style, color: '#F8F8F8' };
            if (cell.tags.includes('secondaryBGColor')) style = { ...style, color: '#EDEFFF' };
            if (cell.tags.includes('selectedBGColor')) style = { ...style, color: '#BCBEF8' };
            if (cell.tags.includes('selectedBorderColor')) style = { ...style, color: '#B2B4F5' };
            if (cell.tags.includes('selectedTextColor')) style = { ...style, color: '#FFFFFF' };
            if (cell.tags.includes('promotionColor')) style = { ...style, color: '#F87A4B' };
            if (cell.tags.includes('notificationColor')) style = { ...style, color: '#E36060' };
        }

        style.color = cell.color ? cell.color : 'var(--AnteTitleColor)';

        if (cell.dataType === 'Array' || cell.displayAsTag) {
            var ar = JSON.parse(stringify(cell.children));
            if (typeof ar === 'string')
                ar = ar
                    // .split(',')
                    .split(/,(?!\d)|(?<!\d),/)// không tách nếu giữa 2 số
                    .map((v) => String(v).trim());

                    
            ar = ar
                .flat()
                .map((v) => v.split(/,(?!\d)|(?<!\d),/)) // không tách nếu giữa 2 số
                .flat()
                .map((v) => String(v).trim())
                .filter((v) => v !== undefined && v !== 0 && v !== null && String(v).trim() !== '');

            let containterStyle = {
                height: 24,
                margin: 2,
                borderRadius: 6,
                backgroundColor: '#e9e9f8',
                flex: 1,
                alignItems: 'center',
                display: 'inline-flex',
                paddingLeft: 7,
                paddingRight: 7,
                paddingTop: 3,
                paddingBottom: 3
            };

            if (cell.backgroundColor) containterStyle.backgroundColor = cell.backgroundColor;
            if (props.backgroundColor) containterStyle.backgroundColor = props.backgroundColor;

            if (cell.height) containterStyle.height = cell.height;
            if (props.height) containterStyle.height = props.height;

            if (cell.paddingLeft) containterStyle.paddingLeft = cell.paddingLeft;
            if (props.paddingLeft) containterStyle.paddingLeft = props.paddingLeft;

            if (cell.paddingRight) containterStyle.paddingRight = cell.paddingRight;
            if (props.paddingRight) containterStyle.paddingRight = props.paddingRight;

            if (cell.paddingTop) containterStyle.paddingTop = cell.paddingTop;
            if (props.paddingTop) containterStyle.paddingTop = props.paddingTop;

            if (cell.paddingBottom) containterStyle.paddingBottom = cell.paddingBottom;
            if (props.paddingBottom) containterStyle.paddingBottom = props.paddingBottom;

            if (cell.margin) containterStyle.margin = cell.margin;
            if (props.margin) containterStyle.margin = props.margin;

            if (cell.marginLeft) containterStyle.marginLeft = cell.marginLeft;
            if (props.marginLeft) containterStyle.marginLeft = props.marginLeft;

            if (cell.marginRight) containterStyle.marginRight = cell.marginRight;
            if (props.marginRight) containterStyle.marginRight = props.marginRight;

            if (cell.marginTop) containterStyle.marginTop = cell.marginTop;
            if (props.marginTop) containterStyle.marginTop = props.marginTop;

            if (cell.marginBottom) containterStyle.marginBottom = cell.marginBottom;
            if (props.marginBottom) containterStyle.marginBottom = props.marginBottom;

            if (cell.margin) containterStyle.margin = cell.margin;
            if (props.margin) containterStyle.margin = props.margin;

            if (props.highLight) {
                // containterStyle.backgroundColor = '#cc650c';
                containterStyle.color = '#fff';
                containterStyle.borderRadius = 6;
                containterStyle.borderWidth = 1;
                containterStyle.borderStyle = 'Solid';
                containterStyle.borderColor = '#fff';
                // containterStyle.fontWeight = 600;
            }

            if (props.hashBackground) {
                var hashKey = hash(stringify(ar) + props.hashBackgroundData).substring(0, 6); // Lấy 6 ký tự đầu làm mã HEX
                let hashColor = darkenColor(hashKey, 0.8); // Giảm độ sáng 40%

                containterStyle.backgroundColor = hashColor;
                // containterStyle.opacity = 0.8;
            }

            let style1 = {
                display: 'inline-table',
                flexWrap: 'wrap'
            };
            let style2 = {
                ...containterStyle,
                ...style,
                color: props.color
            };

            if (cell.right) {
                style1.display = 'inline-flex';
                style1.justifyContent = 'flex-end';
                delete style2.flex;
            }

            return {
                style: style1,
                content: ar.map((a, i) => {
                    return (
                        <div key={i} style={style2}>
                            {a}
                        </div>
                    );
                })
            };
        }

        // if (cell.icon) {
        //     return (
        //         <View
        //             row
        //             {...cell}
        //             key={cell.key}
        //             centerV
        //             style={{
        //                 textAlignVertical: 'center',
        //                 alignContent: 'center',
        //                 flex: 1
        //             }}
        //         >
        //             <AntIcon
        //                 icon={cell.icon}
        //                 color={cell.iconColor}
        //                 {...(cell.iconTags ? cell.iconTags.reduce((obj, i) => ((obj[i] = true), obj), {}) : [])}
        //                 size={14}
        //                 paddingH-0
        //                 marginR-6
        //                 right
        //                 top
        //             />
        //             <Text {...cell} {...tags} style={style} flex centerV>
        //                 {AntLocalization.translateText(cell.children)}
        //             </Text>
        //         </View>
        //     );
        // }

        return {
            style: style,
            content: AntLocalization.translateText(cell.children)
        };
    });

    let ele = renderText(props);

    return (
        <div
            style={{
                fontSizeAdjust: '0.4',
                ...props.style,
                display: 'flex',
                alignItems: 'center',
                verticalAlign: 'middle',
                ...ele.style,
                textWrap: 'wrap',
                height: 'fit-content'
            }}
        >
            {ele.content}
        </div>
    );
}
